import { ContinueWithExistingRunnerCard } from "@/components/onboarding/ContinueWithExistingRunnerCard";
import type { PlainRunner } from "@/queries/runner-queries";
import { type FC } from "react";

export const ContinueWithExistingRunners: FC<{ runners: PlainRunner[] }> = ({ runners }) => {
    return (
        <ul className="flex flex-col gap-2">
            {runners.map((runner) => {
                return (
                    <li key={runner.runnerId}>
                        <ContinueWithExistingRunnerCard runner={runner} />
                    </li>
                );
            })}
        </ul>
    );
};
